import { createSlice } from "@reduxjs/toolkit";
import { getBrands, getBrandsPag } from "./thunks";
import { logOut } from "../authentication/authenticationSlice";

const initialState = {
  list: [],
  listPag: {
    pageIndex: 0,
    totalRecords: 10,
    totalPages: 1,
    pageSize: 10,
    hasPreviousPage: false,
    hasNextPage: false,
    elements: [],
  },
  loading: "idle",
  loadingPag: "idle",
  error: null,
};

const brandsSlice = createSlice({
  name: "brands",
  initialState,
  reducers: {
    clearBrandsError: (state) => {
      state.error = null;
      state.loading = "idle";
    },
  },
  extraReducers: {
    [getBrands.pending]: (state) => {
      state.loading = "loading";
      state.error = null;
    },
    [getBrands.fulfilled]: (state, action) => {
      state.loading = "succeeded";
      state.list = action.payload;
    },
    [getBrands.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.error.message;
    },
    [getBrandsPag.pending]: (state) => {
      state.loading = "loadingPag";
      state.error = null;
    },
    [getBrandsPag.fulfilled]: (state, action) => {
      state.loadingPag = "succeeded";
      state.listPag.elements = action.payload.elements;
      state.listPag.pageIndex = action.payload.pageIndex;
      state.listPag.pageSize = action.payload.pageSize;
      state.listPag.totalRecords = action.payload.totalRecords;
      state.listPag.totalPages = action.payload.totalPages;
      state.listPag.hasPreviousPage = action.payload.hasPreviousPage;
      state.listPag.hasNextPage = action.payload.hasNextPage;
    },
    [getBrandsPag.rejected]: (state, action) => {
      state.loadingPag = "failed";
      state.error = action.error.message;
    },
    [logOut]: (state) => initialState,
  },
});

export const { clearBrandsError } = brandsSlice.actions;
export default brandsSlice.reducer;
